import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'

export interface Quotation2Props {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useQuotation2 = (props: Quotation2Props) => {
  const quotationsData = useSelector(
    (state: RootState) => state.about.quotations
  )

  return {
    ...props,
    quotationsData,
  }
}
